<template>
    <v-container class="" fluid>
        <v-row no-gutters class="">
            <div class=" !w-full !px-5 bg-black h-[calc(100vh-150px)] overflow-scroll  rounded-2xl">
                <div class="">
                    <v-card-title class="justify-center py-6 text-center">
                        <h4 :class="`${routeLink}_fortext !text-2xl font-Handel `">
                            {{ getLockPinStatus ? 'Change Pin Code' : 'Set Pin Code' }}
                        </h4>
                    </v-card-title>
                    <div class="" v-if="getLockPinStatus">
                        <p class="text-slate-300 font-Handel">
                            Enter Your Old Pin
                        </p>
                        <v-otp-input v-model="enteredPinCode" dark class="otp_verify font-Handel" type="password" length="5"
                            @finish="verifyingPinCode"></v-otp-input>
                    </div>
                    <div class="" v-else>
                        <p class="text-slate-300 font-Handel">
                            Set Your New Pin
                        </p>
                        <v-otp-input v-model="enteredNewPinCode" dark class="otp_verify font-Handel" type="password"
                            length="5" @finish="setPinCode"></v-otp-input>
                    </div>
                    <v-expand-transition>
                        <div class="" v-if="verifyOldPin">
                            <p class="text-slate-300 font-Handel">
                                Set Your New Pin
                            </p>
                            <v-otp-input v-model="enteredNewPinCode" dark class="otp_verify font-Handel" type="password"
                                length="5" @finish="setPinCode"></v-otp-input>
                        </div>
                    </v-expand-transition>
                </div>
            </div>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios';
export default {
    data() {
        return {
            enteredPinCode: null,
            enteredNewPinCode: null,
            verifyOldPin: false,
        }
    },
    computed: {
        getLockPinStatus() {
            return this.$store.getters.StateUser.data.pincode_status;
        },
    },
    methods: {
        async verifyingPinCode() {
            try {
                const resp = await axios.post('users/verify/pincode', { pincode: this.enteredPinCode })
                console.log(resp)
                if (resp.data.status == 'Success') {
                    this.verifyOldPin = true
                }
            } catch (error) {
                console.log(error);
                await this.$store.dispatch("errorAction", 'Please Enter Correct Pin Code', {
                    root: true,
                })
            }
        },
        async setPinCode() {
            try {
                const resp = await axios.post('users/pincode', { pincode: this.enteredNewPinCode })
                this.$toast(`${resp.data.message}`, {
                    position: "top-left",
                    timeout: 3000,
                    closeOnClick: true,
                    pauseOnFocusLoss: true,
                    pauseOnHover: true,
                    draggable: true,
                    draggablePercent: 0.6,
                    showCloseButtonOnHover: false,
                    hideProgressBar: false,
                    closeButton: "button",
                    icon: {
                        iconClass: "mdi mdi-checkbox-multiple-marked-outline",
                        iconChildren: "",
                        iconTag: "i"
                    },
                    rtl: false
                });
                this.enteredPinCode = null
                this.enteredNewPinCode = null
                this.verifyOldPin = false
                if (!this.$store.getters.StateUser.data.pincode_status) {
                    const { data } = await axios.get('profiles')
                    this.$store.commit("setUser", data);
                }

            } catch (error) {
                console.error(error);
            }
        }
    },
}
</script>

<style scoped>
.otp_verify:deep(.v-text-field__slot) {
    /* background: linear-gradient(350deg,
       rgba(157, 115, 31, 1) 0%,
  rgba(219, 182, 112, 1) 50%,
       rgba(157, 115, 31, 1) 100%); */
    border: 1px solid black;
    border-radius: 10px;
}

.otp_verify:deep(.v-input__slot fieldset) {
    border: none !important;
}

.otp_verify:deep(.v-input__slot) {
    border-radius: 10px !important;
}
</style>